/**
 * @public
 */
export var WatchedQueryListenerEvent;
(function (WatchedQueryListenerEvent) {
    WatchedQueryListenerEvent["ON_DATA"] = "onData";
    WatchedQueryListenerEvent["ON_ERROR"] = "onError";
    WatchedQueryListenerEvent["ON_STATE_CHANGE"] = "onStateChange";
    WatchedQueryListenerEvent["SETTINGS_WILL_UPDATE"] = "settingsWillUpdate";
    WatchedQueryListenerEvent["CLOSED"] = "closed";
})(WatchedQueryListenerEvent || (WatchedQueryListenerEvent = {}));
//# sourceMappingURL=WatchedQuery.js.map